export class Price {
  constructor(price = {}) {
    this.id = price.id;
    this.unitAmount = price.unit_amount;
  }
}
